











import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
@Component
export default class GoogleMapDialog extends Vue {
  @PropSync('isVisible', { type: Boolean, default: false })
  isModalVisible!: boolean

  @Prop({ type: Number, required: true }) latitude!: number
  @Prop({ type: Number, required: true }) longitude!: number

  @Prop({ type: String, default: '500x250' }) size!: string

  @Prop({ type: String, default: '17' }) zoom!: string

  get homeShopMap() {
    let apiKey = process.env.VUE_APP_GOOGLE_API_KEY
    if (!apiKey) {
      return ``
    }
    return `https://maps.googleapis.com/maps/api/staticmap?center=${this.latitude},${this.longitude}&zoom=${this.zoom}&size=${this.size}&maptype=roadmap&markers=color:red|${this.latitude},${this.longitude}&key=${process.env.VUE_APP_GOOGLE_API_KEY}`
  }

  onCancelClicked() {
    this.$emit('cancel')
  }
}
